class LinkAccSessToAppHourReq {
  constructor(accSessId, appHourId, isSplit, isFirstHalf, PartitionId, BuildingId) {
    this.accountingSessionId = accSessId;
    this.appointmentHourId = appHourId;
    this.isSplit = isSplit;
    this.isFirstHalf = isFirstHalf;
    this.PartitionId = PartitionId;
    this.BuildingId = BuildingId;
    this.isDummy = false;
    this.patientName = "";
    this.sessionName = "";
  }
}

export default LinkAccSessToAppHourReq;